import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ResourceRequest } from '../../../resource-manager/interface/create-resource-request.model';
import { finalize, zip } from 'rxjs';
import { Component, Inject, OnInit } from '@angular/core';
import { Language } from '../../interface/language';
import { AlertService } from '../../../alert/alert.service';
import { I18nService } from '../../i18n.service';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { A11yModule } from '@angular/cdk/a11y';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  standalone: true,
  selector: 'shared-live-resource-dialog',
  templateUrl: './live-resource-dialog.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressBarModule,
    A11yModule,
    MatTooltipModule
  ],
  styleUrls: ['./live-resource-dialog.component.scss']
})
export class LiveResourceDialogComponent implements OnInit {
  formGroup?: FormGroup;
  loading = false;

  constructor(public dialogRef: MatDialogRef<LiveResourceDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: LiveResourceData,
              private alertSvc: AlertService,
              private i18nSvc: I18nService) {
  }

  ngOnInit() {
    this.initForm();
  }

  initForm(): void {
    const resourceGroup: { [key: string]: FormGroup } = {};
    this.data.languages.forEach((language) => {
      resourceGroup[language.id] = new FormGroup({
        id: new FormControl(),
        lang: new FormControl(language),
        text: new FormControl('', Validators.required)
      });
    });

    resourceGroup['resourceKeyGroup'] = new FormGroup({
      resourceKey: new FormControl({ value: this.data.resourceKey, disabled: true },
        Validators.required)
    });

    this.formGroup = new FormGroup(resourceGroup);
  }

  getLangCode(langId: number): string {
    return this.data.languages.find(l => l.id === langId)?.code ?? '';
  }

  onSubmit() {
    if (!this.formGroup) return;
    const requests: ResourceRequest[] = [];
    Object.keys(this.formGroup.controls).forEach(key => {
      if (key !== 'resourceKeyGroup') {
        requests.push(new ResourceRequest(
          this.formGroup?.controls[key].get('lang')?.value,
          this.formGroup?.get('resourceKeyGroup.resourceKey')?.value,
          this.formGroup?.controls[key].get('text')?.value
        ));
      }
    });

    if (requests.length === 0) return;

    this.loading = true;
    zip(requests.map(r => this.i18nSvc.createResource(r)))
      .pipe(finalize(() => this.loading = false))
      .subscribe(success => {
        if (success) {
          this.alertSvc.info('#Created');
          this.i18nSvc.translatedQueue.push(this.formGroup?.get('resourceKeyGroup.resourceKey')?.value);
          this.dialogRef.close();
        }
      });
  }

  closeAndDisable() {
    this.i18nSvc.copywriterMode = false;
    this.dialogRef.close();
  }
}

export interface LiveResourceData {
  languages: Language[];
  resourceKey: string;
}
